export default "__VITE_ASSET__BhXmZtgP__"